<template>

    <div>
        <div class="container" >
            <div class='leftItem'>
                <el-radio-group v-model="itemVal">
                    <el-radio-button label="0">图片管理</el-radio-button>
                    <el-radio-button label="6">文件管理</el-radio-button>
                    <el-radio-button label="1">短信配置</el-radio-button>
                    <el-radio-button label="2">邮箱配置</el-radio-button>
                    <el-radio-button label="3">公众号配置</el-radio-button>
                    <el-radio-button label="4">支付通道</el-radio-button>
                    <el-radio-button label="5">对象储存</el-radio-button>
                </el-radio-group>
            </div>
            <div class='contentItem' v-if="itemVal==0">
                <v-content0></v-content0>
            </div>
            <div class='contentItem' v-if="itemVal==6">
                <v-content6></v-content6>
            </div>
            <div class='contentItem' v-if="itemVal==1">
                <v-content1></v-content1>
            </div>
            <div class='contentItem' v-if="itemVal==2">
                <v-content2></v-content2>
            </div>
            <div class='contentItem' v-if="itemVal==3">
                <v-content3></v-content3>
            </div>
            <div class='contentItem' v-if="itemVal==4">
                <v-content4></v-content4>
            </div>
            <div class='contentItem' v-if="itemVal==5">
                <v-content5></v-content5>
            </div>
        </div>

    </div>
</template>

<script>
import $ from 'jquery';
import vContent6 from './sysConfig/ComFile.vue';
import vContent0 from './sysConfig/ComImg.vue';
import vContent1 from './sysConfig/ComSms.vue';
import vContent2 from './sysConfig/ComEmail.vue';
import vContent3 from './sysConfig/GzhSet.vue';
import vContent4 from './sysConfig/PaySet.vue';
import vContent5 from './sysConfig/SSOConfig.vue';
import bus from '@/components/common/bus';
export default {

    data() {
        return {
            itemVal:'0',
        };
    },
    created() {
        bus.$on('image-choose',  url  => {
            this.form1.icon = url;
            this.form3.icon = url;
            this.showVisible = false;
        });
    },
    //页面加载方法
    mounted: function () {

    },
    components: {
        vContent0,
        vContent1,
        vContent2,
        vContent3,
        vContent4,
        vContent5,
        vContent6,
    },

    methods: {
        handleSelect(key, keyPath) {
            this.itemVal = key;
        },
    }
};
</script>

<style scoped>
</style>
